










































import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import uuid from 'uuid/v4';

@Component({})
export default class TextFieldWidget extends Vue {

  @Inject() public $validator: any;

  @Prop(String) public title!: string;
  @Prop(String) public remark!: string;
  @Prop(String) public inputName!: string;
  @Prop(String) public inputIdProp!: string;
  @Prop(String) public staticInputId!: string;
  @Prop(String) public optionalText!: string;
  @Prop([String, Number]) public dataAttribute!: string | number;
  @Prop({ type: String, default: 'payrollForm' }) public formName!: string;
  @Prop([String, Number]) public initialValue!: string | number;
  @Prop([String, Number]) public placeholder!: string | number;
  @Prop(Number) public maxLength!: number;
  @Prop(Number) public maxValue!: number;
  @Prop(Number) public minValue!: number;
  @Prop(Boolean) public isRequired!: boolean;
  @Prop(Boolean) public isEmail!: boolean;
  @Prop(Boolean) public isEmailGroup!: boolean;
  @Prop(Boolean) public isAlpha!: boolean;
  @Prop(Boolean) public isNumeric!: boolean;
  @Prop(Boolean) public isDisabled!: boolean;
  @Prop(Boolean) public autofocusProp!: boolean;
  @Prop(Boolean) public searchInput!: boolean;
  @Prop(Boolean) public validateOnInput!: boolean;
  @Prop(Boolean) public validateOnBlur!: boolean;
  @Prop(Boolean) public showWarningIcon!: boolean;
  @Prop(Boolean) public clearField!: boolean;
  @Prop(Boolean) public isIdNumber!: boolean;
  @Prop(Boolean) public isPhoneNumber!: boolean;
  @Prop(Boolean) public kabbabValidation!: boolean;

  private inputModel: string = '';
  private maxLengthVal: number = 0;
  private inputId: string = '';
  private htmlName: string = '';

  public created() {
    this.inputId = this.staticInputId || 'input' + uuid();
    this.htmlName = this.inputName || this.$t(this.title).toString();
    if (this.formName && !this.staticInputId) {
      this.inputId = this.formName + '.' + this.inputId;
    }
    if (this.isIdNumber) {
      this.$validator.extend('validIdNumber',
          { // validation for v-select is selected
            getMessage: (field: any) => this.$t('invalidIdNumberMessage', { field }),
            validate: (idNumber: any) => {
              return this.validateIdNumber(idNumber);
            },
          });
    }
    if (this.isPhoneNumber) {
      this.$validator.extend('validPhoneNumber',
          { // validation for v-select is selected
            getMessage: (field: any) => this.$t('invalidPhoneNumberMessage', { field }),
            validate: (phoneNumber: any) => {
              return this.validatePhoneNumber(phoneNumber);
            },
          });
    }
    if (this.isEmail) {
      this.$validator.extend('validEmailAddress',
          { // validation for v-select is selected
            getMessage: (field: any) => this.$t('invalidEmailAddressMessage', { field }),
            validate: (email: any) => {
              return this.validateEmailAddress(email);
            },
          });
    }
    if (this.isEmailGroup) {
      this.$validator.extend('validEmailGroupAddress',
          { // validation for v-select is selected
            getMessage: (field: any) => this.$t('invalidEmailAddressMessage', { field }),  // todo think about err msg
            validate: (emails: string) => {
              return this.validateEmailGroupAddress(emails)
            },
          });
    }
    if (this.isAlpha) {
      this.$validator.extend('validAlphaLetters',
          { // validation for v-select is selected
            getMessage: (field: any) => this.$t('invalidAlphaLettersMessage', { field }),
            validate: (str: any) => {
              return this.validateAlphaLetters(str);
            },
          });
    }
    if (this.kabbabValidation) {
      this.$validator.extend('validKabbabChars',
          { // validation for v-select is selected
            getMessage: (field: any) => this.$t('invalidKabbabCharsMessage', { field }),
            validate: (str: any) => {
              return this.validateSpecialLetters(str);
            },
          });
    }
  }

  public mounted() {
    this.inputModel = typeof this.initialValue === 'number' ? '' + this.initialValue : this.initialValue;
    if (this.initialValue) {
      this.$emit('input', this.inputModel);
    }
    if (this.validateOnInput) {
      const matcher = {
        name: this.inputId,
        scope: this.formName,
      };
      const field: any = this.$validator.fields.find(matcher);
      if (field) {
        field.update({ events: 'input' });
      }
    }
    if (this.validateOnBlur) {
      const matcher = {
        name: this.inputId,
        scope: this.formName,
      };
      const field: any = this.$validator.fields.find(matcher);
      if (field) {
        field.update({ events: 'blur' });
      }
    }
  }

  public updateInputModel($event: any): void {
    if (this.maxLengthVal && $event.target.value.length > this.maxLengthVal) {
      $event.target.value = $event.target.value.slice(0, this.maxLengthVal);
    }
    this.inputModel = $event.target.value;
    this.$emit('input', this.inputModel.length > 0 ? this.inputModel : null);
  }

  public updateNull($event: any): void {
    this.inputModel = '';
    this.$emit('input', null);
  }

  public blurInputModel($event: any): void {
    this.$emit('blur', $event.target.value);
  }

  get inputValue(): string | number {
    if (!this.inputModel) {
      return this.initialValue || '';
    }
    return this.inputModel || '';
  }

  get validators(): any {
    const validator: any = {};
    if (this.isRequired) {
      validator.required = this.isRequired;
    }
    if (this.maxLength) {
      validator.max = this.maxLength;
      this.maxLengthVal = this.maxLength + 1;
    }
    if (this.isNumeric) {
      validator.numeric = this.isNumeric;
      if (this.maxValue || this.maxValue === 0) {
        validator.max_value = this.maxValue;
      }
      if (this.minValue || this.minValue === 0) {
        validator.min_value = this.minValue;
      }
    }
    if (this.isEmail) {
      // validator.email = this.isEmail;
      validator.validEmailAddress = this.isEmail;
    }
    if (this.isEmailGroup) {
      validator.validEmailGroupAddress = this.isEmailGroup;
    }
    if (this.isAlpha) {
      // validator.email = this.isEmail;
      validator.validAlphaLetters = this.isAlpha;
    }
    if (this.isIdNumber) {
      validator.validIdNumber = true;
    }
    if (this.isPhoneNumber) {
      validator.validPhoneNumber = true;
    }
    if (this.kabbabValidation) {
      validator.validKabbabChars = true;
    }
    return validator;
  }

  public validateIdNumber(idNum: any) {
    let strId: any = String(idNum).trim();
    if (strId.length > 9) {
      return false;
    }
    if (strId.length < 9) {
      while (strId.length < 9) {
        strId = '0' + strId;
      }
    }
    let counter: any = 0;
    let rawVal: any;
    let actualVal: any;
    for (let i = 0; i < strId.length; i++) {
      rawVal = Number(strId[i]) * ((i % 2) + 1);
      actualVal = rawVal > 9 ? (rawVal - 9) : rawVal;
      counter += actualVal;
    }
    return (counter % 10 === 0);
  }

  public validatePhoneNumber(phoneNum: any) {
    if (!phoneNum) {
      phoneNum = '';
    }
    return !!(phoneNum
        .match('^(0|((02|03|04|08|09|072|073|074|076|077|078|050|051|052|053|054|055|056|057|058|059)([-]?)([0-9]{7})))$'));
  }

  public validateEmailAddress(email: any) {
    if (!email) {
      email = '';
    }
    const re = /^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,})$/;
    return re.test(email.toLowerCase());

  }
  public validateEmailGroupAddress(emails: string):boolean {
    try {
      if(!emails) return false
      const emailGroup:string[] = emails.split(/[,;]+/).map((item: string) => item.trim());
      return !emailGroup.some(email=> !this.validateEmailAddress(email));
    }
    catch (error){
      return false
    }
  }

  public validateAlphaLetters(str: any) {
    if (!str) {
      str = '';
    }
    const re = /^[a-z\u0590-\u05fe]+$/i;
    return re.test(str.toLowerCase());

  }

  public validateSpecialLetters(str: any) {
    if (!str) {
      str = '';
    }
    const re = /--/g;
    return !re.test(str.toLowerCase());
  }

}
